import data from './emoji.json'

let lightMarkdown = {} as any,
    tokens = getTokens(),
    regex = getRegex(tokens),
    plainToken = '',
    options = {} as any,
    flavors = {
        slack: {
            bold: true,
            italics: true,
            strikethrough: true,
            pre: true,
            code: true,
            longQuote: true,
            quote: true,
            autoLink: true,
            paragraph: true,
            lineBreaks: true,
            emoji: true,
            user: true,
            channel: true,
            broadcast: true
        },
        skype: {
            bold: true,
            italics: true,
            strikethrough: true,
            pre: false,
            code: false,
            longQuote: false,
            quote: false,
            autoLink: true,
            paragraph: false,
            lineBreaks: true,
            emoji: true,
            user: true,
        }
    };

enum Flavors {
    slack = 'slack',
    skype = 'skype'
}

lightMarkdown.setOption = function (key: string, value: string) {
    options[key] = !!value;
    return this;
};

lightMarkdown.getOption = function (key: string) {
    return options[key];
};


lightMarkdown.setFlavor = function (flavorName: Flavors) {
    const flavor = flavors[flavorName] as any;
    if (flavor) {
        for (const option in flavor) {
            if (flavor.hasOwnProperty(option)) {
                options[option] = flavor[option];
            }
        }
    }
    return this;
};


lightMarkdown.toHtml = function (md: string, members: any[], channels: any[]) {
    md = escapeHtml(md);
    let plains = [] as any[];

    // Replace all tokens
    tokens.forEach(function (t: any) {
        if (options[t.name]) {
            md = md.replace(t.regex, function (match, g1, g2) {
                if (!g2 ||
                    (t.requireNonTokens && !regex.nonTokensChars.test(g2)) ||
                    (t.token.length === 1 && (g2[0] === t.token || g2.slice(-1) === t.token)) ||
                    (t.spaceWrapIgnored && g2[0] === ' ' && g2.slice(-1) === ' '))
                    return match;

                if (typeof t.processContent === 'function') {
                    g2 = t.processContent(g2);
                }
                if (t.plainContent) {
                    const plainIndex = plains.push(g2) - 1;
                    g2 = plainToken + plainIndex;
                }

                if (t.preserveNewLine) {
                    g2 = g2.replace(/\n/g, "<br />");
                }

                const newText = `${g1}<${t.elementName}>${g2}</${t.elementName}>`;

                return newText;
            });
        }
    });

    if (options.longQuote) {
        md = md.replace(regex.multilineQuote, function (match, g1, g2) {
            if (match === '&gt;&gt;&gt;')
                return match;

            // trim start unless there are more '>' ahead
            g2 = g2.replace(/^([\s]*)(&gt;)*/, function (m: string, gg1: string, gg2: string) {
                return gg2 ? m : '';
            });
            return '<blockquote>' + g2 + '</blockquote>';
        });
    }

    if (options.quote) {
        md = md.replace(regex.singleLineQuote, function (match, g1, g2) {
            if (match === '&gt;')
                return match;
            g2 = g2.replace(/\n&gt;/g, '\n');
            return '<blockquote>' + g2 + '</blockquote>';
        });
    }

    if (options.emoji) {
        md = md.replace(regex.emoji, function (match, g1) {
            // const filtered = data.filter((e: any) => e.name === g1)
            // const emoji = filtered && filtered.length > 0 ? filtered[0] : null

            // if (!emoji) return match

            // return `&#x${emoji.unicode}`
            const emoji = data[g1] ? data[g1] : null
            if (!emoji) return match

            return emoji
        });
    }

    if (options.user) {
        md = unescapeHtml(md)
        md = md.replace(regex.userMention, function (match, g1, g2, g3, g4, g5) {
            if (g5) return `@${g5}`
            const filteredUser = members.filter((u) => u.id === g2)
            const user = filteredUser && filteredUser.length ? filteredUser[0] : {}

            return `@${user.username || g2}`
        });
    }

    if (options.channel) {
        md = unescapeHtml(md)
        md = md.replace(regex.channelMention, function (match, g1, g2, g3, g4, g5) {
            if (g5) return `#${g5}`

            const filteredChannel = channels.filter((c) => c.id === g2)
            const channel = filteredChannel && filteredChannel.length ? filteredChannel[0] : {}

            return `#${channel.name || g2}`
        });
    }

    if (options.broadcast) {
        md = unescapeHtml(md)
        md = md.replace(regex.broadcastMention, function (match, g1, g2) {
            if (g2 === 'everyone' || g2 === 'channel' || g2 === 'here') {
                return `@${g2}`
            }

            return escapeHtml(match)
        });
    }

    if (options.autoLink) {
        // Replace links
        md = unescapeHtml(md)
        md = md.replace(regex.url, function (match, url, label) {
            var linkWrapperOpen = '',
                linkWrapperClose = '';

            if (!label) {
                label = url
            } else {
                label = label.replace("|", "");
            }

            // Link can be wrapped by round brackets, an allowed character in an url
            if (url.substring(0, 1) === '(') {
                var lastCharacter = url.slice(-1);
                linkWrapperOpen = '(';
                url = url.slice(1, lastCharacter === ')' ? -1 : url.length);
                linkWrapperClose = lastCharacter === ')' ? ')' : '';
            }


            return `${linkWrapperOpen}<a href="${url}" target="_blank">${label}</a>${linkWrapperClose}`;
        });
    }

    if (options.paragraph) {
        // Create paragraphs
        // md = escapeHtml(md)
        let m;
        let doubleLineIndexes = [];
        while ((m = regex.doubleLineBreak.exec(md))) {
            doubleLineIndexes.push({
                start: m.index,
                length: m[0].length
            });
        }
        while ((m = regex.blockquoteTags.exec(md))) {
            doubleLineIndexes.push({
                start: m.index,
                length: m[0].length,
                suffix: m[0]
            });
        }
        doubleLineIndexes.push({
            start: md.length,
            length: 0
        });

        doubleLineIndexes.sort(function (a, b) {
            return a.start - b.start;
        });

        let withParagraphs = '';
        let startIndex = 0;
        doubleLineIndexes.forEach(function (doubleLine) {
            let paragraph = '';
            let paragraphContent = md.substring(startIndex, doubleLine.start);
            if (paragraphContent) {
                // if(regex.broadcastMention.test(paragraph)) {
                //     paragraphContent = escapeHtml(paragraphContent)
                // }
                paragraph = `<p>${paragraphContent}</p>`;
            }
            if (doubleLine.suffix) {
                paragraph += doubleLine.suffix;
            }
            withParagraphs += paragraph;
            startIndex = doubleLine.start + doubleLine.length;
        });
        md = withParagraphs;
    }

    if (options.lineBreaks) {
        // Create line breaks
        md = md.replace(regex.singleLineBreak, '<br />');
        md = md.replace(/(\u21b5)/gm, '<br />');
    }
    // Restore plain parts
    plains.forEach(function (p, plainIndex) {
        md = md.replace(plainToken + plainIndex, p);
    });

    return md;
};


function escapeHtml(content: string) {
    if (content) {
        content = content.replace(/>/g, '&gt;');
        content = content.replace(/</g, '&lt;');
    }
    return content;
}

function unescapeHtml(content: string) {
    if (content) {
        content = content.replace(/&gt;/g, '>');
        content = content.replace(/&lt;/g, '<');
    }
    return content;
}

type ITokenObj = {
    name: string
    token: string
}

function getRegex(tokens: ITokenObj[]) {
    let allTokenChars = tokens.map(function (t) {
        return t.token.length === 1 ? t.token : '';
    }).join();

    const nonTokensCharsRegex = new RegExp('[^' + allTokenChars + ']');

    // Multiline quote >>>
    const multilineQuoteRegex = /(^|\n)&gt;&gt;&gt;([\s\S]*$)/;

    // Single line quote > or sequential lines that start with >.
    const singleLineQuoteRegex = /(^|\n)&gt;(([^\n]*)(\n&gt;[^\n]*)*)/g;

    // Two new lines in a row
    const doubleLineBreakRegex = /\r?\n\r?\n\r?/g;

    // Single line break
    const singleLineBreakRegex = /\r?\n\r?/g;

    // Url
    const urlRegex = /<(https?:[^|>]+)(\\|([^>]+))?>/g;

    //emoji
    const emojiRegex = /:([^:\s]*)(?:::[^:\s]*)*:/g;

    //user
    const userRegex = /<([@]?(U[^|>]+))(\\|([|])([^>|]+))?>/g;

    //channel
    const channelRegex = /<([#]?(C[^|>]+))(\\|([|])([^>|]+))?>/g;

    //broadcast
    const broadcastRegex = /<(!+([^>]+))([^>]+)?>/g;

    return {
        nonTokensChars: nonTokensCharsRegex,
        multilineQuote: multilineQuoteRegex,
        singleLineQuote: singleLineQuoteRegex,
        blockquoteTags: /<\/?blockquote>/ig,
        doubleLineBreak: doubleLineBreakRegex,
        singleLineBreak: singleLineBreakRegex,
        url: urlRegex,
        emoji: emojiRegex,
        userMention: userRegex,
        channelMention: channelRegex,
        broadcastMention: broadcastRegex
    };
}

// From http://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex
function escapeRegExp(str: string) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}

function getTokens() {
    var tokens = [
        { name: 'pre', token: '```', elementName: 'pre', multiline: true, preserveNewLine: true },
        { name: 'code', token: '`', elementName: 'code', ignoreAfter: true },
        { name: 'bold', token: '*', elementName: 'b', requireNonTokens: true, spaceWrapIgnored: true },
        { name: 'italics', token: '_', elementName: 'i', requireNonTokens: true },
        { name: 'strikethrough', token: '~', elementName: 's', requireNonTokens: true, spaceWrapIgnored: true },
    ];
    tokens.forEach(function (t: any) {
        if (!t.regex) {
            var before = '(^|[\\s\\?\\.,\\-!\\^;:{(\\[%$#+="])';
            var content = t.multiline ? '([\\s\\S]*?)?' : '(.*?\\S *)?';
            var after = t.ignoreAfter ? '' : '(?=$|\\s|[\\?\\.,\'\\-!\\^;:})\\]%$~{\\[<#+="])';
            var token = escapeRegExp(t.token);
            var pattern = before + token + content + token + after;
            t.regex = new RegExp(pattern, 'g');
        }
    });
    return tokens;
}

lightMarkdown.setFlavor('slack');

export default lightMarkdown